import apiHelper from '../utils/apiHelper';

export const contentService = {
    // Get all content items from SharePoint
    getAllContent: async () => {
        try {
            const response = await apiHelper.get('/api/graph/content');
            return response.data || [];
        } catch (error) {
            console.error('Error fetching content:', error);
            throw error;
        }
    },

    // Get content by ID
    getContentById: async (contentId) => {
        try {
            const response = await apiHelper.get(`/api/graph/content/${contentId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching content by ID:', error);
            throw error;
        }
    },

    // Update existing content
    updateContent: async (contentId, contentData, userName) => {
        try {
            // Map frontend field names to SharePoint field names
            const fields = {
                Title: contentData.Title || contentData.title || null,
                Content: contentData.Content || contentData.content || null,
                Publish: contentData.Publish !== undefined ? contentData.Publish : 
                        (contentData.publish !== undefined ? contentData.publish : true)
            };

            console.log('Updating content fields:', fields);

            const requestBody = {
                fields: fields
            };

            const response = await apiHelper.put(`/api/graph/updateContent/${contentId}`, requestBody);
            return response.data;
        } catch (error) {
            console.error('Error updating content:', error);
            throw error;
        }
    },

    // Get content filtered by category (based on Title or a pattern)
    getContentByCategory: async (category) => {
        try {
            const allContent = await contentService.getAllContent();
            
            // Filter based on title containing category keywords
            const categoryKeywords = {
                'policy': ['policy', 'regulatory', 'regulation', 'compliance'],
                'capability': ['capability', 'innovation', 'capability & innovation'],
                'council': ['council', 'member', 'strategic']
            };

            const keywords = categoryKeywords[category.toLowerCase()] || [category.toLowerCase()];
            
            return allContent.filter(item => {
                const title = (item.Title || '').toLowerCase();
                return keywords.some(keyword => title.includes(keyword));
            });
        } catch (error) {
            console.error('Error fetching content by category:', error);
            throw error;
        }
    }
}; 